<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  (onHide)="onHide()">
  <div class="mb-2 left-sidebar clientdetails">
    <form [formGroup]="clientForm">
      <h2 *ngIf="headingStatus">
        {{ createNewContact }}
      </h2>
      <h1 class="mb-3" *ngIf="!headingStatus">{{ updateNewContact }}</h1>
      <div class="row">
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label">first name</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              name="firstname"
              type="text"
              class="form-control"
              id="firstname"
              formControlName="firstName"
              [ngClass]="{ 'has-error': formErrors['firstName'] }"
              (blur)="logValidationErrors()" />

            <span class="error-msg" *ngIf="formErrors['firstName']">
              {{ formErrors["firstName"] }}
            </span>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label">last name</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              name="lastname"
              type="text"
              class="form-control"
              id="lastname"
              formControlName="lastName"
              [ngClass]="{ 'has-error': formErrors['lastName'] }"
              (blur)="logValidationErrors()" />

            <span class="error-msg" *ngIf="formErrors['lastName']">
              {{ formErrors["lastname"] }}
            </span>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label">phone number</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              jni-phone-number-formatting
              name="phone"
              type="text"
              class="form-control"
              id="phone"
              placeholder=""
              formControlName="phoneNumber"
              [ngClass]="{ 'has-error': formErrors['phoneNumber'] }"
              (blur)="logValidationErrors()" />

            <span class="error-msg" *ngIf="formErrors['phoneNumber']">
              {{ formErrors["phoneNumber"] }}
            </span>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label">Email Address</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              name="email"
              type="text"
              class="form-control"
              id="email"
              placeholder=""
              formControlName="email"
              [ngClass]="{ 'has-error': formErrors['email'] }"
              (blur)="logValidationErrors()" />

            <span class="error-msg" *ngIf="formErrors['email']">
              {{ formErrors["email"] }}
            </span>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="has-float-label">
            <label class="form-label">type</label>
            <p-select
              formControlName="type"
              [options]="type"
              optionLabel="name"
              optionValue="name">
            </p-select>
          </div>
        </div>
        <div class="col-12 mb-2" [hidden]="true">
          <div class="has-float-label">
            <label class="form-label">title</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              name="title"
              type="text"
              class="form-control"
              id="title"
              placeholder=""
              formControlName="title" />
          </div>
        </div>
        <div class="col-12 mb-2" [hidden]="true">
          <div class="has-float-label">
            <label class="form-label">electronicAddressIdD365</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              name="electronicAddressIdD365"
              type="text"
              class="form-control"
              id="electronicAddressIdD365"
              placeholder=""
              formControlName="electronicAddressIdD365" />
          </div>
        </div>
        <div class="col-12 mb-3 mt-3">
          <div class="switcher">
            <h2 class="mb-2">Primary:</h2>
            <div class="d-flex align-items-center form-switch gap-2">
              <label class="form-check-label" for="rcCheck">{{
                this.clientForm.get("isPrimary")?.value
              }}</label>
              <p-toggleswitch
                name="rcCheck"
                (checked)="(false)"
                id="rcCheck"
                formControlName="isPrimary" />
            </div>
          </div>
        </div>
      </div>
      <!-- <button
        class="btn btn-primary me-3 post"
        type="submit"
        [disabled]="!clientForm.valid"
        (click)="onSubmit()">
        Save
      </button> -->

      <p-button
        label="Save"
        [disabled]="!clientForm.valid"
        (click)="onSubmit()" />
    </form>
  </div>
</p-drawer>
